import React, { useEffect, useState } from "react";
import { Initial } from "./Initial";
import { NewButtonForm } from "./NewButtonForm";
import { NewPaymentButton } from "./NewPaymentButton";
import View from "../../../../utils/View";
import { PAYMENT_BUTTON_COMPONENTS } from "../../../../../constants";

const DEFAULT_VALUES = {
  reference: "",
  amount: "",
  stores: 1,
  transactionId: "",
  cancelUrl: "",
  successUrl: "",
};

const PaymentButton = () => {
  const [paymentButtonPage, setPaymentButtonPage] = useState(
    PAYMENT_BUTTON_COMPONENTS[0]
  );

  const [formValues, setFormValues] = useState(DEFAULT_VALUES);

  useEffect(() => {
    // Reset form values when going back to initial page
    if (paymentButtonPage === PAYMENT_BUTTON_COMPONENTS[0]) {
      setFormValues(DEFAULT_VALUES);
    }
  }, [paymentButtonPage]);

  return (
    <View translateTitleKey="menu.botonDePago">
      {paymentButtonPage === PAYMENT_BUTTON_COMPONENTS[0] && (
        <Initial setPaymentButtonPage={setPaymentButtonPage} />
      )}
      {paymentButtonPage === PAYMENT_BUTTON_COMPONENTS[1] && (
        <NewButtonForm
          setPaymentButtonPage={setPaymentButtonPage}
          formValues={formValues}
          setFormValues={setFormValues}
        />
      )}
      {paymentButtonPage === PAYMENT_BUTTON_COMPONENTS[2] && (
        <NewPaymentButton
          setPaymentButtonPage={setPaymentButtonPage}
          formValues={formValues}
        />
      )}
    </View>
  );
};

export default PaymentButton;
